import { Button, Chip, Grid, Modal } from '@material-ui/core';
import { CheckCircleRounded, Description, HomeWork, RadioButtonUncheckedOutlined, School, Work } from '@material-ui/icons';
import { getStudentAffiliate } from '@webapps/business';
import { useQuery } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Tooltip from 'components/Tooltip';
import { useState } from 'react';


const AffiliateInfo = ({ id, school, status }) => {
  const { css, classes, cx, global, theme: { spacing }, } = useStyles(styles);
  const { data: { data: info = [] } = {} } = useQuery(getStudentAffiliate, {
    key: ['infoStudentBusinessAffiliate', id],
    variables: { id, type: 'business', status: 'enclosed' },
  });


  return (
    <Grid container style={{ flexDirection: 'column' }}>
      <Grid className={cx(classes.address, global.infoText)} >
        <div>
          <Work className={global.infoIcon} />
        </div>
        <div className={[global.ellipsis85, css({
          // textAlign: 'left'
        })]}>{info[0]?.job?.label ? (info[0]?.job?.label.length >= 45 ? info[0]?.job?.label.slice(0, 45) + '...' : info[0]?.job?.label) : 'Poste non renseigné'}</div>
      </Grid>

      <Grid className={cx(classes.address, global.infoText)} >
        <div>
          <Description className={global.infoIcon} />
        </div>
        <div>{info[0]?.contractType?.label ? info[0]?.contractType?.label : 'Type de contrat non rensigné'}</div>
      </Grid>

      <Grid className={cx(classes.address, global.infoText)} >
        <div>
          <Chip
            classes={{
              colorPrimary: css({
                background: '#fbd3d5',
                color: '#F50057',
              }),
            }}
            className={classes.chip}
            color="primary"
            label={status === "EXCLUDED" ? "Exclu" : "Abandon"}
            size='18px'
          />
        </div>
      </Grid>
    </Grid>
  )
};

const styles = ({ spacing }) => ({
  formations: {
    marginTop: spacing(2),
  },
  infoCandidat: { display: 'flex', alignItems: 'center', width: '100%' },
  tableHead: {
    '&.MuiTableCell-head': {
      color: 'white',
    },
  },
  address: {
    display: 'flex',
    alignItems: 'center',
    marginTop: spacing(1),
  },
  chip: {
    marginTop: spacing(1),
    marginBottom: spacing(1),
    borderRadius: '10.0px',
    padding: spacing(2.5),
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontWeight: 'regular',
    '@media only screen and (max-width:768px)': { padding: spacing(2) },
  },
});

export default AffiliateInfo